import { render } from "./IntegrationOauthForm.vue?vue&type=template&id=7c595553"
import script from "./IntegrationOauthForm.vue?vue&type=script&lang=js"
export * from "./IntegrationOauthForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__